// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"style_videoWrapper__1Z7Ps","embed":"style_embed__1FbtR"};